module.exports = __webpack_public_path__ + "img/196.10c021cc.jpg";